import {
    getReservationAPI,
    DownloadReservationAPI,
    sendTripSummaryEmailAPI,
} from "../../../utils/api.js";
import { errorAlert, successAlert } from "../../../utils/helper.js";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getSingleReservation = createAsyncThunk(
    "reservation/getSingleReservation",
    async ({ id, isTrip }, { rejectWithValue }) => {
      try {
        const response = await getReservationAPI(id, isTrip);
        return response;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const DownloadSingleReservation = createAsyncThunk(
  "reservation/downloadSingleReservation",
  async ({ id, isTrip }, { rejectWithValue }) => {
    try {
      const response = await DownloadReservationAPI(id, isTrip);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendTripSummaryEmail = createAsyncThunk(
  "reservation/sendTripSummaryEmail",
  async (tripId, { rejectWithValue }) => {
    try {
      const response = await sendTripSummaryEmailAPI(tripId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const initialState = {
    reservation: [],
    url: [],
    status: 'idle',
    error: null,
    saving: false,
    loading: false,
    emailSending: false,
};

const reservationSlice = createSlice({
    name: 'reservation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder

      .addCase(getSingleReservation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleReservation.fulfilled, (state, action) => {
        state.reservation = action?.payload?.data?.trip;
        state.error = null;
        state.loading = false;
      })
      .addCase(getSingleReservation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
      })

      .addCase(DownloadSingleReservation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(DownloadSingleReservation.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;

        if (action.payload) {
          try {
            const pdfBlob = new Blob([action.payload], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(pdfUrl), 30000);
          } catch (error) {
            console.error("Error handling PDF:", error);
          }
        }
      })
      .addCase(DownloadSingleReservation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
        errorAlert("Could Not Download Price Summary");
      })

      // ─── Send Trip Summary Email ──────────────
      .addCase(sendTripSummaryEmail.pending, (state) => {
        state.emailSending = true;
      })
      .addCase(sendTripSummaryEmail.fulfilled, (state) => {
        state.emailSending = false;
        successAlert("Trip summary email sent successfully!");
      })
      .addCase(sendTripSummaryEmail.rejected, (state, action) => {
        state.emailSending = false;
        errorAlert(action.payload?.message || "Failed to send trip summary email");
      });
    },
});

export const selectReservationLoading = (state) => state.reservation.loading;
export const selectSingleReservation = (state) => state.reservation.reservation;
export const selectEmailSending = (state) => state.reservation.emailSending;
export const downloadSingleReservation = (state) => state.reservation.url;

export default reservationSlice.reducer;
